import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InternalComponent } from "./internal.component";
import { PermissionGuard } from "../services/permission.guard";
import { CommonComponent } from "../shared/common"
import { ResumeBuildComponent } from "./resume-build/resume-build.component"; 
import { UploadDocumentComponent } from "../internal/upload-document/upload-document.component";
import { CompleteProfileComponent } from "../internal/complete-profile/complete-profile.component";
import { AuthGuard } from "../services/auth.guard";
import { SkillsComponent } from "./skills/skills.component";
import { EducationComponent } from "./education/education.component";
import { AddEduComponent } from "./education/add-edu/add-edu.component";
import { WorkExpComponent } from "./work-exp/work-exp.component";
import { AddWorkComponent } from "./work-exp/add-work/add-work.component";
import { VolunteerComponent } from "./volunteer/volunteer.component";
import { AddVolComponent } from "./volunteer/add-vol/add-vol.component";
import { ProjectsComponent } from "./projects/projects.component";
import { AddProjectsComponent } from "./projects/add-projects/add-projects.component";
import { AwardsComponent } from "./awards/awards.component";
import { AddAwardComponent } from "./awards/add-award/add-award.component";
import { LiceneseComponent } from "./licenese/licenese.component";
import { AddLiceneseComponent } from "./licenese/add-licenese/add-licenese.component";
import { LanguageComponent } from "./language/language.component";
import { AddLanguageComponent } from "./language/add-language/add-language.component";
import { JobPreferencesComponent } from "./job-preferences/job-preferences.component";
import { ResumeOverviewComponent } from "./resume-overview/resume-overview.component"; 

const routes: Routes = [
  { path: "", component: InternalComponent,
     children:[
      { path: "upload-document", component: UploadDocumentComponent }, 
      { path: "complete-profile", component: CompleteProfileComponent },
      { path: "resume-build", component: ResumeBuildComponent }, 
      { path: "skills", component: SkillsComponent }, 
      { path: "education", component: CommonComponent,
        children:[
          {path: "", component: EducationComponent},
          {path :"add",component:AddEduComponent}
        ]
      }, 
      { path: "experience", component: CommonComponent,
        children:[
          {path: "", component: WorkExpComponent},
          {path :"add",component:AddWorkComponent}
        ]
      }, 
      { path: "volunteer", component: CommonComponent,
        children:[
          {path: "", component: VolunteerComponent},
          {path :"add",component:AddVolComponent}
        ]
      },
      { path: "projects", component: CommonComponent,
        children:[
          {path: "", component: ProjectsComponent},
          {path :"add",component:AddProjectsComponent}
        ]
      }, 
      { path: "awards", component: CommonComponent,
        children:[
          {path: "", component: AwardsComponent},
          {path :"add",component:AddAwardComponent}
        ]
      }, 
      { path: "licenese", component: CommonComponent,
        children:[
          {path: "", component: LiceneseComponent},
          {path :"add",component:AddLiceneseComponent}
        ]
      },  
      { path: "language", component: CommonComponent,
        children:[
          {path: "", component: LanguageComponent},
          {path :"add",component:AddLanguageComponent}
        ]
      },  
      { path: "jobs", component: JobPreferencesComponent},   
      { path: "overview", component: ResumeOverviewComponent}, 
      { path: "",canActivate: [AuthGuard],loadChildren: () => import("src/app/jobseeker-component/jobseeker-component.module").then(m => m.JobseekerComponentModule)},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InternalRoutingModule {}
